import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "../../style/AllCarsAdmin.css";
import "../../style/AuctionReports.css";
import BidderModal from "../BidderModal";

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
}

function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function AuctionCarCard({ src, auction, highestBid }) {
  return (
    <div className="ar-car-card">
      <div className="ar-car-card-media">
        {src ? (
          <img src={src} alt={`${auction.Carro?.marca} ${auction.Carro?.modelo}`} />
        ) : (
          <div className="ar-car-card-placeholder">Sin imagen</div>
        )}
      </div>

      <div className="ar-car-card-body">
        <h3 className="ar-car-card-title">
          {auction.Carro?.marca} {auction.Carro?.modelo} {auction.Carro?.anio}
        </h3>

        <div className="ar-car-card-stats">
          <div className="ar-car-stat">
            <span className="ar-car-stat-label">Inicio</span>
            <span className="ar-car-stat-value">{formatDate(auction.Inicio)}</span>
          </div>
          <div className="ar-car-stat">
            <span className="ar-car-stat-label">Fin</span>
            <span className="ar-car-stat-value">{formatDate(auction.Fin)}</span>
          </div>
          <div className="ar-car-stat ar-car-stat-highlight">
            <span className="ar-car-stat-label">Oferta más alta</span>
            <span className="ar-car-stat-value">
              L. {formatNumberWithCommas(highestBid ?? 0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function AuctionReportDetail() {
  const { id } = useParams();
  const { authToken, logout } = useAuth();
  const navigate = useNavigate();
  const [auction, setAuction] = useState(null);
  const [bidders, setBidders] = useState([]);
  const [ticketBuyers, setTicketBuyers] = useState([]);
  const [selectedBid, setSelectedBid] = useState(null);
  const [username, setUsername] = useState("");

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!authToken) {
        navigate("/");
        return;
      }
      try {
        const resUser = await api.get("usuario/getbyToken");
        setUsername(resUser.data.nombre);

        const resAuction = await api.get(`auctions/${id}`);
        setAuction(resAuction.data);

        const resTicketBuyers = await api.get(`transactions/auction/${id}`);
        setTicketBuyers(resTicketBuyers.data);

        const resBidders = await api.get(`bids/auction/${id}/top`);
        setBidders(resBidders.data);

      } catch (err) {
        console.error("Error fetching report", err);
      }
    };
    fetchData();
  }, [id, authToken, navigate]);

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <div className="auction-report-detail">
              <div className="ar-detail-topbar">
                <button
                  type="button"
                  className="ar-back-btn"
                  onClick={() => navigate("/auctionreports")}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                  Volver al listado
                </button>
                <h2 className="ar-detail-title">Reporte de Subasta</h2>
              </div>

              <div className="ar-detail-grid">
                <div className="ar-detail-left">
                  {auction && (
                    <AuctionCarCard
                      src={auction.Carro?.imagenes?.[0]}
                      auction={auction}
                      highestBid={auction.highestBid}
                    />
                  )}

                  {auction && (
                    <div className="ar-summary-card">
                      <h4 className="ar-summary-title">Detalles</h4>
                      <div className="ar-summary-row">
                        <span className="ar-summary-label">ID de subasta</span>
                        <code className="ar-summary-id" title={auction._id}>
                          {auction._id}
                        </code>
                      </div>
                      <div className="ar-summary-row">
                        <span className="ar-summary-label">Auto</span>
                        <span className="ar-summary-value">
                          {auction.Carro?.marca} {auction.Carro?.modelo}{" "}
                          {auction.Carro?.anio}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="ar-detail-right">
                  <div className="ar-section">
                    <div className="ar-section-header">
                      <h3 className="ar-section-title">Pujas registradas</h3>
                      <span className="ar-section-count">{bidders.length}</span>
                    </div>
                    {bidders.length > 0 ? (
                      <div className="ar-bids-table-wrap">
                        <table className="ar-bids-table">
                          <thead>
                            <tr>
                              <th>Comprador</th>
                              <th className="ar-bids-amount">Oferta</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bidders.map((bid) => (
                              <tr
                                key={bid._id}
                                onClick={() => setSelectedBid(bid)}
                              >
                                <td>{bid.user ? bid.user.nombre : "Anónimo"}</td>
                                <td className="ar-bids-amount">
                                  L. {formatNumberWithCommas(bid.amount)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="ar-empty-small">
                        No hay pujas registradas
                      </div>
                    )}
                  </div>

                  <div className="ar-section">
                    <div className="ar-section-header">
                      <h3 className="ar-section-title">Compradores de tickets</h3>
                      <span className="ar-section-count">
                        {ticketBuyers.length}
                      </span>
                    </div>
                    {ticketBuyers.length > 0 ? (
                      <div className="ar-ticket-list">
                        {ticketBuyers.map((t) => {
                          const name = t.user?.nombre || "—";
                          const initial = (name[0] || "?").toUpperCase();
                          return (
                            <div className="ar-ticket-item" key={t._id}>
                              <div className="ar-ticket-avatar">{initial}</div>
                              <div className="ar-ticket-info">
                                <p className="ar-ticket-name">{name}</p>
                                <p className="ar-ticket-contact">
                                  {[t.user?.telefono, t.user?.email]
                                    .filter(Boolean)
                                    .join(" · ") || "Sin contacto"}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="ar-empty-small">
                        No hay compradores de tickets registrados
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <BidderModal
                show={!!selectedBid}
                bidder={selectedBid}
                auction={auction}
                onClose={() => setSelectedBid(null)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AuctionReportDetail;
